import React from 'react';
import ButtonSecondary from 'components/shared/ButtonSecondary';
import Text from 'components/shared/Text';

import styles from './styles.module.scss';

export const QtyPercentageButtons = props => {
  return (
    <div className={styles.quickBtns}>
      <ButtonSecondary styles={[styles.quickBtn]} onClick={() => props.onChangeQuantity(0.1)}>
        <Text>10%</Text>
      </ButtonSecondary>
      <ButtonSecondary styles={[styles.quickBtn]} onClick={() => props.onChangeQuantity(0.25)}>
        <Text>25%</Text>
      </ButtonSecondary>
      <ButtonSecondary styles={[styles.quickBtn]} onClick={() => props.onChangeQuantity(0.5)}>
        <Text>50%</Text>
      </ButtonSecondary>
      <ButtonSecondary styles={[styles.quickBtn]} onClick={() => props.onChangeQuantity(0.75)}>
        <Text>75%</Text>
      </ButtonSecondary>
      <ButtonSecondary styles={[styles.quickBtn]} onClick={() => props.onChangeQuantity(1)}>
        <Text>MAX</Text>
      </ButtonSecondary>
    </div>
  );
};
